export default __webpack_public_path__ + "613cd4b0b2a7f97db63b295d47967a69.svg";